import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Check, Copy, LoaderCircle } from 'lucide-react';
import { formatCurrency } from './formularioParts/utils';
import {
  CompraEventoDetalhe,
  buscarCompraEvento,
  confirmarCompraEvento,
  consultarPagamentoEvento
} from './eventoAdicionalData';

const EventoPagamentoPublico: React.FC = () => {
  const { compraId = '' } = useParams();
  const [dados, setDados] = useState<CompraEventoDetalhe | null>(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [verificando, setVerificando] = useState(false);
  const [erroVerificacao, setErroVerificacao] = useState('');
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    let ativo = true;
    buscarCompraEvento(compraId)
      .then((resultado) => {
        if (ativo) setDados(resultado);
      })
      .catch((error: Error) => {
        if (ativo) setErro(error.message);
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });
    return () => {
      ativo = false;
    };
  }, [compraId]);

  const verificarPagamento = async () => {
    if (!dados?.payment.id) return;
    setVerificando(true);
    setErroVerificacao('');
    try {
      const atual = await consultarPagamentoEvento(dados.payment.id);
      const status = await confirmarCompraEvento(compraId, {
        id: atual.id,
        status: atual.status,
        invoiceUrl: atual.invoiceUrl
      });
      if (status === 'confirmado') {
        setDados((atualDados) => (atualDados ? { ...atualDados, pago: true } : atualDados));
      } else {
        setErroVerificacao('Pagamento ainda não identificado. Aguarde alguns instantes e tente novamente.');
      }
    } catch (error) {
      setErroVerificacao((error as Error).message);
    } finally {
      setVerificando(false);
    }
  };

  const copiarCodigoPix = () => {
    if (!dados?.payment.pixQrCode) return;
    navigator.clipboard.writeText(dados.payment.pixQrCode);
    setCopiado(true);
    window.setTimeout(() => setCopiado(false), 2000);
  };

  return (
    <div className="checkout-overlay evento-page">
      <div className="evento-page-content">
        <div className="evento-logo-wrap">
          <img src="/logo.png" alt="Colônia de Férias" className="evento-logo" />
        </div>
        <div className="checkout-modal">
          <div className="checkout-header">
            <div>
              <h2>Pagamento do Evento</h2>
              <p>Bingo e Cachorro-quente</p>
            </div>
          </div>

        {carregando && (
          <div className="checkout-result">
            <LoaderCircle className="spin" size={32} />
            <p>Carregando pagamento...</p>
          </div>
        )}

        {!carregando && erro && (
          <div className="checkout-form">
            <div className="checkout-error">{erro}</div>
          </div>
        )}

        {!carregando && !erro && dados && dados.pago && (
          <div className="checkout-result evento-success">
            <Check size={48} />
            <h3>Pagamento confirmado!</h3>
            <p>
              Obrigado, {dados.nomeResponsavel}. A participação de {dados.nomeCrianca} no evento está garantida.
            </p>
          </div>
        )}

        {!carregando && !erro && dados && !dados.pago && (
          <div className="checkout-result">
            <h3>Escaneie o QR Code</h3>
            <p className="evento-crianca-selecionada">
              {dados.nomeCrianca}
              {dados.turma ? ` (${dados.turma})` : ''}
            </p>
            {dados.payment.pixQrCodeUrl && (
              <img className="pix-qr-image" src={`data:image/png;base64,${dados.payment.pixQrCodeUrl}`} alt="QR Code PIX" />
            )}
            <div className="pix-copy-row">
              <input readOnly value={dados.payment.pixQrCode || ''} />
              <button type="button" title="Copiar código PIX" onClick={copiarCodigoPix}>
                <Copy size={18} />
              </button>
            </div>
            {copiado && <p className="evento-copiado">Código copiado!</p>}
            <p className="checkout-total">{formatCurrency(dados.payment.value)}</p>
            {erroVerificacao && <div className="checkout-error">{erroVerificacao}</div>}
            <button type="button" className="checkout-primary" onClick={verificarPagamento} disabled={verificando}>
              {verificando ? <LoaderCircle className="spin" size={18} /> : null} Já fiz o pagamento
            </button>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default EventoPagamentoPublico;
